/* global Sys, Core */
Sys.ns("Core");

/**
 * The G4 controller.
 *
 * @class Core.G4Controller
 * @extends Core.Controller
 */
Core.G4Controller = {

    constructor: function() {
        Core.G4Controller.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupEvents: function() {
        var me = this;

        me.on({
            "notify:stateHandler.enteringBeforeLoaderCloseState": me.initG4IfActive,
            "notify:stateHandler.enteringMinimumRoundTimeEnforcementState": me.minimumRoundTimeEnforcement,
            "notify:stateHandler.enteringSpinningState": me.onStartSpin
        });
    },

    /**
     * Initializes G4 mode by requesting changes according to configuration if it is active.
     *
     * @returns {void}
     */
    initG4IfActive: function() {
        var me = this, g4Config;

        if (me.model.readData("isG4") || me.model.isG4PropertyDefined()) {
            // Read G4Config ig G4 mode is true or any of the config parameters is available
            g4Config = me.model.readData("G4Config");

            // Dispatch Module Changes
            me.requestModuleChanges(g4Config.modules);

            // Dispatch Setting Changes
            me.requestSettingChanges(g4Config.settings);

            if (me.model.readData("disabledDuringRound")) {
                me.fireEvent("request:spinButton.addProperty", "disabledDuringRound", me.MODULE_NAME);
            }
        }
    },

    /**
     * If minimum round time limit hasn't been reached the game will be prevented from entering idle state until it has.
     *
     * @returns {void}
     */
    minimumRoundTimeEnforcement: function() {
        var me = this,
            timeout,
            previousRoundsTimer,
            minimumRoundTimeLeft;

        if (me.model.isNewRound()) {
            minimumRoundTimeLeft = me.model.getMinimumTimeLeft();
            previousRoundsTimer = me.model.readData("roundExtensionTimer");

            if (minimumRoundTimeLeft > 0) {
                // clear timeout
                if (Sys.isDefined(previousRoundsTimer)) {
                    clearTimeout(previousRoundsTimer);
                }

                /* DEBUG_START*/
                console.warn("G4.minimumRoundTimeEnforcement: added time before idle: " + minimumRoundTimeLeft + "ms");

                /* DEBUG_END*/

                timeout = setTimeout(function() {
                    me.fireEvent("notify:g4.minimumRoundTimePassed");
                }, minimumRoundTimeLeft);
                me.model.storeData("roundExtensionTimer", timeout);
            }
            else {
                /* DEBUG_START*/
                console.info("G4.minimumRoundTimeEnforcement: no extra time needed");

                /* DEBUG_END*/

                me.fireEvent("notify:g4.minimumRoundTimePassed");
            }
        }
    },

    /**
     * On spin start, time is stored.
     *
     * @returns {void}
     */
    onStartSpin: function() {
        this.model.storeData("isNewRound", true);
        this.model.setRoundStartTime();
    },

    /**
     * Request changes to game settings.
     *
     * @param {Object[]} settings Settings.
     * @returns {void}
     */
    requestSettingChanges: function(settings) {
        var me = this;

        // Iterate module config, dispatch request event
        Sys.each(settings, function(setting) {
            if (!(typeof setting.enabled === "undefined")) {
                if (setting.enabled) {
                    me.dispatchRequestEnableSettingEvent(setting.name);
                }
                else if (!setting.enabled) {
                    me.dispatchRequestDisableSettingEvent(setting.name, setting.offValue);
                }
            }
        });
    },

    /**
     * Request changes to modules.
     *
     * @param {Object[]} modules Modules.
     * @returns {void}
     */
    requestModuleChanges: function(modules) {
        var me = this;

        // Iterate module config, dispatch request event
        Sys.each(modules, function(module) {
            if (!(typeof module.enabled === "undefined")) {
                if (module.enabled) {
                    me.dispatchRequestEnableModuleEvent(module.name);
                }
                else if (!module.enabled) {
                    me.dispatchRequestDisableModuleEvent(module.name);
                }
            }
        });
    },

    /**
     * @param {string} settingName The name of the setting.
     * @param {*} [offValue] The value that the setting should be given to turn the setting off.
     * @returns {void}
     */
    dispatchRequestDisableSettingEvent: function(settingName, offValue) {
        var me = this;

        if (Sys.isDefined(offValue)) {
            me.fireEvent("request:settingsManager.storeValue", settingName, offValue);
        }
        me.fireEvent("request:settingsManager.disableSetting", settingName);
        me.fireEvent("request:settingsManager.lockSetting", settingName, me.MODULE_NAME);
    },

    dispatchRequestEnableSettingEvent: function(settingName, settingValue) {
        var me = this;

        me.fireEvent("request:settingsManager.enableSetting", settingName);
    },

    dispatchRequestDisableModuleEvent: function(moduleName) {
        this.fireEvent("request:" + moduleName + ".disableInMode", "g4");
    },

    dispatchRequestEnableModuleEvent: function(moduleName) {
        this.fireEvent("request:" + moduleName + ".enableInMode", "g4");
    }
};

Core.G4Controller = Sys.extend(Core.Controller, Core.G4Controller, "Core.G4Controller");
